/**
 A really simple event bus, used to send events to
 display the flash message.
 */

import Vue from 'vue';

export default new Vue();
